/*--------------------------------------------------
  Gorgios Chat Window - Triggers (2021/06/16)
--------------------------------------------------*/
function shopifyContextInit() {
  if (window.GorgiasChat && GorgiasChat && GorgiasChat.hasOwnProperty("on")) {
    GorgiasChat.init().then(res => {
      GorgiasChat.setShopifyContext('sukoshi-mart-online.myshopify.com');
    });
  }
}

function customTextInit() {
  let gorgiasChatCustomText = {
    "introductionText": "How can we help?",
    "offlineIntroductionText": "We'll be back tomorrow",
    "actionPostbackError": "An error occurred while processing your action. Please try again.",
    "clickToRetry": "Message not delivered. Click to retry.",
    "conversationTimestampHeaderFormat": "MMMM D",
    "fetchHistory": "Load more",
    "fetchingHistory": "Retrieving history...",
    "invalidFileError": "Only images are supported. Choose a file with a supported extension (jpg, jpeg, png, gif, or bmp).",
    "messageError": "An error occurred while sending your message. Please try again.",
    "messageIndicatorTitlePlural": "({count}) New messages",
    "messageIndicatorTitleSingular": "({count}) New message",
    "messageRelativeTimeDay": "{value}d ago",
    "messageRelativeTimeHour": "{value}h ago",
    "messageRelativeTimeJustNow": "Just now",
    "messageRelativeTimeMinute": "{value}m ago",
    "messageTimestampFormat": "h:mm A",
    "messageSending": "Sending...",
    "messageDelivered": "Delivered",
    "tapToRetry": "Message not delivered. Tap to retry.",
    "unsupportedMessageType": "Unsupported message type.",
    "unsupportedActionType": "Unsupported action type.",
    "headerText": "Gorgias Team",
    "inputPlaceholder": "Type a message...",
    "emailCapturePlaceholder": "your@email.com",
    "emailCaptureInputLabel": "Get notified by email",
    "emailCaptureOnlineTriggerText": "Leave us your email and we will reply soon.",
    "emailCaptureOnlineThanksText": "Thanks! We'll email you at {email} if you leave.",
    "emailCaptureOfflineTriggerText": "We're away, leave us your email and we'll respond shortly.",
    "emailCaptureOfflineThanksText": "Thanks {email}! We'll get back to you shortly.",
    "emailCaptureRequiredEmailPlaceholder": "Leave your email",
    "emailCaptureRequiredMessagePlaceholder": "Write your message",
    "backLabelBackInAMinute": "Back in 1 minute",
    "backLabelBackInMinutes": "Back in {value} minutes",
    "backLabelBackInAnHour": "Back in 1 hour",
    "backLabelBackInHours": "Back in {value} hours",
    "backLabelBackInDays": "Back in {value} days",
    "backLabelBackTomorrow": "Back tomorrow",
    "campaignClickToReply": "Click to reply",
    "poweredByGorgias": "Powered by Gorgias",
    "send": "Send"
  }


  if (window.GorgiasChat && GorgiasChat && GorgiasChat.hasOwnProperty("on") && GorgiasChat.hasOwnProperty("updateTexts")) {
    GorgiasChat.init().then(res => {
      window.GORGIAS_CHAT_TEXTS = gorgiasChatCustomText
      GorgiasChat.updateTexts(gorgiasChatCustomText)
    });
  }
}

function customStylesInit() {
  let gorgiasChatWindow = document.querySelector("#gorgias-chat-container iframe#chat-window");

  if (gorgiasChatWindow === null) {
    console.warn("Could not find Gorgias chat window");
    return;
  }

  // custom stylesheet
  let gorgiasChatCustomStylesheetRel = "stylesheet";
  let gorgiasChatCustomStylesheetType = "text/css";
  let gorgiasChatCustomStylesheetUrl = "//sukoshi-mart-sandbox.myshopify.com/cdn/shop/t/62/assets/gorgias-chat-customizations.css?v=81099968743806556061734988154";

  let gorgiasChatCustomStylesheet = document.createElement("link");
  let gorgiasChatHead = gorgiasChatWindow.contentWindow.document.querySelector("head");

  gorgiasChatCustomStylesheet.setAttribute("rel", gorgiasChatCustomStylesheetRel);
  gorgiasChatCustomStylesheet.setAttribute("type", gorgiasChatCustomStylesheetType);
  gorgiasChatCustomStylesheet.setAttribute("href", gorgiasChatCustomStylesheetUrl);

  if (gorgiasChatHead === null) {
    console.warn("Could not find Gorgias Chat head.");
  } else {
    gorgiasChatHead.appendChild(gorgiasChatCustomStylesheet);
  }
}

function customGorgiasChatInit() {
  let initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

  initGorgiasChatPromise.then(async () => {
    // init phase
    shopifyContextInit();
    customTextInit();
    customStylesInit();
  });
}

customGorgiasChatInit();
